import { render, staticRenderFns } from "./SubscriptionsStatisticsRenewals.vue?vue&type=template&id=23d38b33"
import script from "./SubscriptionsStatisticsRenewals.vue?vue&type=script&lang=js"
export * from "./SubscriptionsStatisticsRenewals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports